import {
  ItemListContainer,
  ItemWrapper,
  ItemInfoWrapper,
  ItemTitleWrapper,
  ColumnWrapper,
  ItemLeftWrapper,
  ItemActionsWrapper,
} from "./itemList.styled";
import { Typography, Icon, Button } from "@ann/web-components";

const EmailItem = ({ info, onOpen }) => {
  const handleOpen = () => {
    onOpen?.(info);
  };

  return (
    <ItemListContainer>
      <ItemWrapper>
        <ItemLeftWrapper>
          <ItemTitleWrapper>
            <Icon name="email" size="small" />
            <Typography category="subtitle" weight="bold" size="medium">
              {info.title}
            </Typography>
          </ItemTitleWrapper>
          <ItemInfoWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Sender
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.sender}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Opens
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.opens}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Clicks
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.clicks}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Status
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.status}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Thread
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.thread}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Timestamp
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.timestamp}
              </Typography>
            </ColumnWrapper>
          </ItemInfoWrapper>
        </ItemLeftWrapper>
        <ItemActionsWrapper>
          <Button
            size="small"
            type="secondary"
            icon="chevronRight"
            pill
            onClick={handleOpen}
          />
        </ItemActionsWrapper>
      </ItemWrapper>
    </ItemListContainer>
  );
};

export default EmailItem;